import React, { Component, forwardRef } from 'react'
import { connect } from "react-redux";
import TextField from './TextField';
import DropDown from './Dropdown';
import CheckBox from './CheckBox';
import userPic from "../assets/images/user.png";
import service from '../services';
import AWS from "aws-sdk";
import SimpleReactValidator from 'simple-react-validator';
//Loader import
import Loader from "./loader";
import ModalMessage from './ModalMessage';
import commonImage from '../commonImage';
import Textarea from './Textarea';

let sub;

const mapStateToProps = state => ({
    countries : state.countries
});
class CreatePressuser extends Component {
    constructor(props) {
        super(props)
        this.state = {
            sameAs: false,
            userImage: null,
            dataLoader: false,
            shareInfo: '',
            primarilyReside: '',
            primarilyStateReside: '',
            locationError: '',
            otherRaceOriginError: '',
            otherIsPersonDisabilityError: '',
            otherAccessibilityNeedError: '',
            imagePreloader: false,
            messageModal: false,
            emailModal: false,
            roleWise: this.props.roleWise,
            image1: '',
            for: '',
            passError: false,
            imagePopup:false,
            isValidCode:true,
            imageValideMessage:'',
            emailExistError:'',
            otherAccommodationsEventError:'',
            otherIndustryAssociationError:'',
            jobTitleError:'',
            companyNameError:'',
            passAcessType: [
                {
                    MainCategory: { name: 'Select All Pass', checked: true, identifier: 'allAccessPass', show: true },
                    SubCategory: []
                },
            ],
            allAccess: [],
            passIndu: [],
            pressUserData: {
                extPhone: '',
                referredBy: '',
                email: this.props.defaultEmail,
                passAccess: [],
                pressAppliedDiscountCode: null,
                fname: "",
                lname: "",
                companyName: "",
                attendingIndependently: false,
                jobTitle: "",
                secondaryEmail: "",
                assistantName: "",
                primaryPhone: "",
                primaryPhoneType: "",

                mailAddress: {
                    street: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'Select From Below'
                },

                festivalInfo: {
                    accessibilityNeed: [],
                    otherAccessibilityNeed: '',
                    attendLocation: "",
                    interestedIn: [],
                    favoriteFilm: '',
                    attended: ""
                },

                demoGraphicInfo: {
                    gender: "",
                    isTransGender: "",
                    raceOrigin: [],
                    otherRaceOrigin: "",
                    accommodationsEvent: [],
                    otherAccommodationsEvent: "",
                    industryAssociation: [],
                    otherIndustryAssociation: "",
                    sexualOrientation: "",
                    isPersonDisability: [],
                    otherIsPersonDisability:''
                },
                collab: {
                    primaryInterest: '',
                    secondaryInterest: []
                }
            },
            complist:[]
        }
        // this.clear = this.clear.bind(this);
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([a-zA-Z ' -]*)$/i) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 ' , . & !]*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                phone: {  // name the rule
                    message: 'Please add valid phone no.',
                    rule: (val, params, validator) => {
                      return val && validator.helpers.testRegex(val, /^\+?[0-9]\d{1,15}$/)
                    },
                },
                Required: {  // name the rule
                    message: 'This field is required.',
                    rule: (val, params, validator) => {
                      return validator.helpers.testRegex(val, /^[\s\t\r\n]*\S+/ig) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
            }
        });
        this.apiserve = new service();
        this._randomProfileSuffix = null;
    }

    getProfileFilename = () => {
        const { pressUserData, for: mode } = this.state;
        if (mode === 'Edit' && pressUserData && pressUserData?._id) {
            return `profile_${pressUserData?._id?.slice(-10)}`;
        }
        if (!this._randomProfileSuffix) {
            this._randomProfileSuffix = Math.floor(Math.random() * 9000000000 + 1000000000).toString();
        }
        return `profile_${this._randomProfileSuffix}`;
    }

    updateState = (newState) => {
        this.setState({
            ...newState,
            isEdited: true
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.createuser && !prevProps.createuser) {
            setTimeout(() => {
                if (window.Sundance) {
                    window.Sundance.rebuild();
                }
            }, 100);
        }
    }

    componentWillUnmount = () => {
        if (window.Sundance && this._sdkUploadListener) {
            window.Sundance.off('universal_sundance_actions', this._sdkUploadListener);
        }
        sub.unsubscribe();
    }

    componentDidMount() {
        this.apiserve.sendevent("admin|getPasses", {});
        this.apiserve.sendevent("admin|getCouponList", {});
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response?.event) {
                case "admin|createUser":
                    if (!response?.error) {
                        this.apiserve.success('User created successfully!')
                        this.setState({ dataLoader: false })
                        this.CloseModal();

                    }
                    else {
                        // this.apiserve.error(response?.data?.error) 
                        this.setState({ dataLoader: false, emailModal: true })
                        // this.props.CloseModal();
                    }
                    break;

                case "admin|getUser":
                    if (!response?.error) {
                        let check_all = []
                        let data = response?.data
                        if(response?.data?.additionalRoles?.includes('pressUser')){
                            this.state.passAcessType.map(item => {
                                item.MainCategory.checked = false
                                item.SubCategory.map(sub =>
                                    sub.checked = false
                                )
                            })
                            if (data?.pressPassType !== 'Select from below') {
                                if (data?.pressPurchaseStatus === 'complete' || (data?.pressPurchaseStatus === "pending" && data?.pressStatus === 'confirmed') || (data?.pressStatus === 'pendingConfirmation')) {
                                    data.passAccess = []
                                    data.passAccess.push(data?.pressPassType)
                                }
                            } else {
                                data.passAccess = data?.passAccess?.length === 0 ? check_all : data?.passAccess
                            }
                            this.state.passAcessType.map(item => {
                                item.SubCategory.map(sub => {
                                    sub.checked = data?.pressStatus !== "confirmed" ? !sub?.globalSoldOut && data?.passAccess?.includes(sub?.identifier) : data?.passAccess?.includes(sub?.identifier)
                                    sub?.checked && check_all.push(sub?.identifier)
                                    data?.pressStatus === "confirmed" ?
                                        this.setState({
                                            allAccess: [...this.state.allAccess, sub?.identifier],
                                        }) 
                                    :
                                        !sub?.globalSoldOut &&
                                        this.setState({
                                            allAccess: [...this.state.allAccess, sub?.identifier]
                                        })
                                })
                            })
                        } else {
                            this.state.passAcessType.map(item => {
                                item.SubCategory.map(sub => {
                                    sub.checked = true
                                    sub?.checked && check_all.push(sub?.identifier)
                                    !sub?.globalSoldOut &&
                                    this.setState({
                                        allAccess: [...this.state.allAccess, sub?.identifier]
                                    })
                                })
                            })
                        }
                        data.passAccess = [...new Set([...check_all, ...(data?.passAccess || [])])];
                        this.setState({
                            dataLoader: false,
                            pressUserData: data,
                            email:response?.data?.email
                        }, () => {
                            if (window.Sundance) window.Sundance.rebuild();
                        })
                        if(response?.data?.pressAppliedDiscountCode){
                            this.checkDiscount(response?.data?.pressAppliedDiscountCode?.identifier)
                        }
                        if(response?.data?.isEarlyPrice){
                            this.setState({complist:this.state.complist})
                        }
                    }
                    else {
                        this.apiserve.error(response?.data?.error)
                        this.setState({ dataLoader: false })
                    }
                    break;

                case "admin|updateUser":
                    if (!response?.error) {
                        this.apiserve.success('User updated successfully!')
                        this.setState({ dataLoader: false, isEdited:false })
                        this.apiserve.sendevent("admin|getUser", { userId: this.state.pressUserData?.userId || this.state.pressUserData?._id, allSearch: false,adminRole:this.props.roleWise });
                    }
                    else {
                        this.apiserve.error(response?.data?.error)
                        this.setState({ dataLoader: false })
                        this.props.CloseModal();
                    }
                    break;
                case "admin|getPasses":
                    if (!response?.error) {
                        let passType = this.state.passAcessType
                        passType.map(item => {
                            item.SubCategory = ['prod2.cms.festival.sundance.org','prod1.cms.festival.sundance.org','prod3.cms.festival.sundance.org'].includes(window.location.hostname) ? response?.data : response?.data?.filter(_ => _.hideFromLive === false)
                            // item.MainCategory.show = response?.data?.length === 0 ? false : true
                            item.SubCategory.map(sub => {
                                !sub?.globalSoldOut &&
                                    this.setState({
                                        pressUserData: { ...this.state.pressUserData, passAccess: [...(this.state.pressUserData?.passAccess || []), sub?.identifier] }
                                    })
                                if (this.state.for !== 'Edit') {
                                        !sub?.globalSoldOut &&
                                        this.setState({
                                            allAccess: [...this.state.allAccess, sub?.identifier]
                                        })
                                }
                            }
                            )
                        })
                        this.setState({
                            passAcessType: passType
                        })
                    }
                    break;
                case "admin|getUserByEmail":
                    if (!response?.error) {
                        this.setState({emailExistError:''})
                    }
                    else {
                        this.setState({emailExistError:response?.data?.error})
                    }
                    break;
                case 'stripeProduct|isValidCouponCode':
                    if(!response?.error){
                        this.setState({isValidCode:response?.data?.isValidCode})
                    }
                    break;
                case 'admin|getCouponList':
                    if(!response?.error){
                        this.setState({complist:response?.data})
                    }
                    break;
                default:
                    break;
            }
        })

        this._sdkUploadListener = (payload) => {
            if (payload.event === 'ImageUploadStart') {
                this.setState({ imagePreloader: true });
            }
            if (payload.event === 'ImageUpload') {
                const newImage = payload.data.key;
                if (this.state.pressUserData && this.state.pressUserData?._id) {
                    this.apiserve.sendevent("user|updateImage", { image: newImage, userId: this.state.pressUserData?._id });
                }
                this.updateState({
                    imagePreloader: false,
                    pressUserData: {
                        ...this.state.pressUserData,
                        image: newImage,
                    },
                });
            }
        };
        if (window.Sundance) {
            window.Sundance.on('universal_sundance_actions', this._sdkUploadListener);
            window.Sundance.rebuild();
        }
    }

    checkDiscount = (comp) => {
        this.apiserve.sendevent('stripeProduct|isValidCouponCode',{"code":comp})
    }

    ClosemessageModal = () => {
        this.setState({
            messageModal: false,
        })
    }

    ErrorScroll = () => {
        setTimeout(() => {
            var firstError = document.querySelector('.editaccount .srv-validation-message');
            if (firstError) firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
    }

    CloseEmailModal = () => {
        this.setState({
            emailModal: false
        })
    }

    ChangeProfile = (e) => {
        let file = e.target.files[0];
        console.log(file.name,"nameee");
        if (!file.name.match(/\.(jpg|jpeg|png|jpe|jif|jfif|JPG|JPEG|PNG|JIF|JFIF|JPE)$/)) {
            this.setState({
                imagePopup:true,
                imageValideMessage:"Please select valid image."
            })
        } else {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = (event) => {

                this.setState({})
                setTimeout(() => {
                    this.imageUploadScreen(file,event.target.result);
                }, 0);
            };
        }
    }

    imageUploadScreen = (file,img) => {
        this.updateState({ imagePreloader: true })
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
            this.updateState({
                imagePreloader: false,
                pressUserData: {
                    ...this.state.pressUserData,
                    image: value
                }
            })
        });
    };

    CloseImageModal = () => {
        this.setState({imagePopup:false})
    }

    handleCheck = (e) => {
        const { name, checked } = e.target;
        this.updateState({
            pressUserData: {
                ...this.state.pressUserData,
                [name]: checked
            }
        })
    }

    handleCompCheck = (e, identifier) => {
        const { name, checked, id } = e.target;
        this.updateState({isValidCode:true})
        if(checked){
            this.checkDiscount(identifier)
        }
        if (checked) {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    'pressAppliedDiscountCode': {_id:id, identifier:identifier},
                }
            })
        } else {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    'pressAppliedDiscountCode': null,
                    passType: "Select from below"
                }
            })
        }
    }

    handleUncheck = (e) => {
        const { name, value, checked } = e.target;
        if (checked) {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: value
                    }
                }
            })
        }
        else {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: ''
                    }
                }
            })
        }
    }

    handleFestivalCheck = (e) => {
        const { name, value, checked } = e.target;
        if (name === 'raceOrigin' || name === 'accommodationsEvent' || name === 'industryAssociation') {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: value
                    }
                }
            })
        }
        else {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    festivalInfo: {
                        ...this.state.pressUserData.festivalInfo,
                        [name]: value
                    }
                }
            })
        }
    }

    handleFestivalBooleanCheck = (e) => {
        const { name, value } = e.target;

        this.updateState({
            pressUserData: {
                ...this.state.pressUserData,
                festivalInfo: {
                    ...this.state.pressUserData.festivalInfo,
                    [name]: JSON.parse(value)
                }
            }
        })
    }

    handleEmailText = (e) => {
        const { name, value } = e.target;
        let regex = /^[a-zA-Z0-9](?!.*[.\-+_]{2})[a-zA-Z0-9._+-]*[a-zA-Z0-9]@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/
        let oldEmail = this.state.email
        this.updateState({
            pressUserData: {
                ...this.state.pressUserData,
                [name]: value
            }
        })
        if((value.match(regex) !== null && oldEmail !== value) && this.state.pressUserData?._id){
            this.apiserve.sendevent("admin|getUserByEmail", { escapeEmail: oldEmail, email: value });
        }
    }

    handleText = (e) => {
        const { name, value } = e.target;

        if (!e.target.validity.valid) {
            return null
        }

        if (name === 'attendLocation') {
            if (value) {
                this.updateState({
                    locationError: ''
                })
            }
            else {
                this.updateState({
                    locationError: 'This field is required.'
                })
            }

        }

        if (name === 'otherAccessibilityNeed') {
            if (value) {
                this.updateState({
                    otherAccessibilityNeedError: ''
                })
            }
            else {
                this.updateState({
                    otherAccessibilityNeedError: 'This field is required.'
                })
            }
        }

        if (name === "favoriteFilm" || name === 'otherAccessibilityNeed' || name === 'attendLocation' || name === 'workSector' || name === 'guildAffiliation' || name === 'attended') {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    festivalInfo: {
                        ...this.state.pressUserData.festivalInfo,
                        [name]: value
                    }
                }
            })
        }
        else if (name === "primarilyStateReside" || name === "primarilyreside" || name === 'bornYear' || name === "artistCarerStage" || name === "bornCountry" || name === "education") {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: value
                    }
                }
            })
        } else if(name === 'otherAccommodationsEvent' || name === 'otherIndustryAssociation' || name === 'otherRaceOrigin' || name === 'otherIsPersonDisability') {
            if(value.length > 100){
              if(name === 'otherAccommodationsEvent'){
                this.updateState({
                  otherAccommodationsEventError:'This Field allows only 100 Characters.'
                })
              } else if(name === 'otherIndustryAssociation'){
                this.updateState({
                  otherIndustryAssociationError:'This Field allows only 100 Characters.'
                })
              } else if(name === 'otherIsPersonDisability'){
                this.updateState({
                  otherIsPersonDisabilityError:'This Field allows only 100 Characters.'
                })
              } else{
                this.updateState({
                  otherRaceOriginError:'This Field allows only 100 Characters.'
                })
              }
            } else {
              if(value.length === 0){
                if(name === 'otherAccommodationsEvent'){
                  this.updateState({
                    otherAccommodationsEventError:'This Field is required.'
                  })
                } else if(name === 'otherIndustryAssociation'){
                  this.updateState({
                    otherIndustryAssociationError:'This Field is required.'
                  })
                } else if(name === 'otherIsPersonDisability'){
                  this.updateState({
                    otherIsPersonDisabilityError:'This Field is required.'
                  })
                } else{
                  this.updateState({
                    otherRaceOriginError:'This Field is required.'
                  })
                }
              } else{
                if(name === 'otherAccommodationsEvent'){
                  this.updateState({
                    otherAccommodationsEventError:''
                  })
                } else if(name === 'otherIndustryAssociation'){
                  this.updateState({
                    otherIndustryAssociationError:''
                  })
                } else if(name === 'otherIsPersonDisability'){
                  this.updateState({
                    otherIsPersonDisabilityError:''
                  })
                } else {
                  this.updateState({
                    otherRaceOriginError:''
                  })
                }
              }
              this.updateState({
                pressUserData: {
                  ...this.state.pressUserData,
                  demoGraphicInfo: {
                    ...this.state.pressUserData.demoGraphicInfo,
                    [name]: value
                  },
                },
              });
            }
          }
        else if (name === 'country' || name === 'street' || name === 'city' || name === 'state' || name === 'zip' || name === 'addressLine2') {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    mailAddress: {
                        ...this.state.pressUserData.mailAddress,
                        [name]: value
                    }
                }
            })
        }
        else if (name === 'primaryInterest') {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    collab: {
                        ...this.state.pressUserData.collab,
                        [name]: value
                    }
                }
            })
        }
        else if (name === 'addressLine2Billing' || name === 'cityBilling' || name === 'countryBilling' || name === 'stateBilling' || name === 'streetBilling' || name === 'zipBilling') {
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    accountBillingAddress: {
                        ...this.state.pressUserData.accountBillingAddress,
                        [name]: value
                    }
                }
            })
        }
        else {
            if(name === 'jobTitle' || name === 'companyName' ){
                if(value.length > 50){
                    if( name === 'jobTitle'){
                        this.updateState({
                            jobTitleError:'Job Title cannot exceed 50 characters.'
                        })
                    } else {
                        this.updateState({
                            companyNameError:'Company/Organization Name cannot exceed 50 characters.'
                        })
                    }
                } else {
                    if( name === 'jobTitle'){
                        this.updateState({
                            jobTitleError:''
                        })
                    } else {
                        this.updateState({
                            companyNameError:''
                        })
                    }
                }
            }
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    [name]: value
                }
            })
        }
    }

    copyAddress = (e) => {
        if (e.target.checked) {
            this.updateState({
                sameAs: true,
                pressUserData: {
                    ...this.state.pressUserData,
                    mailAddress: {
                        ...this.state.pressUserData.mailAddress,
                        street: this.state.pressUserData?.accountBillingAddress?.streetBilling,
                        addressLine2: this.state.pressUserData?.accountBillingAddress?.addressLine2Billing,
                        city: this.state.pressUserData?.accountBillingAddress?.cityBilling,
                        country: this.state.pressUserData?.accountBillingAddress?.countryBilling,
                        state: this.state.pressUserData?.accountBillingAddress?.stateBilling,
                        zip: this.state.pressUserData?.accountBillingAddress?.zipBilling
                    }
                }
            })
        } else {
            this.updateState({
                sameAs: false
            })
        }
    }

    clear = (e) => {
        e.preventDefault();
        this.state.passAcessType.forEach(item => {
            item.MainCategory.checked = false;
            item.SubCategory.forEach(sub => { sub.checked = false; });
        });
        this.validator.hideMessages();
        this.setState({
            allAccess: [],
            passAcessType: [...this.state.passAcessType],
            sameAs: false,
            primarilyReside: '',
            primarilyStateReside: '',
            locationError: '',
            passError: false,
            isValidCode: true,
            imagePopup: false,
            imageValideMessage: '',
            image1: '',
            shareInfo: '',
            emailExistError: '',
            otherRaceOriginError: '',
            otherAccessibilityNeedError: '',
            otherIsPersonDisabilityError: '',
            otherAccommodationsEventError: '',
            otherIndustryAssociationError: '',
            jobTitleError: '',
            companyNameError: '',
            pressUserData: {
                userId: this.state.pressUserData?._id,
                _id: this.state.pressUserData && this.state.pressUserData?._id === undefined ? undefined : 'id',
                email: this.state.pressUserData && this.state.pressUserData?._id === undefined ? '' : this.state.pressUserData?.email,
                extPhone: '',
                primarilyReside: '',
                primarilyStateReside: '',
                passType: this.state.pressUserData && this.state.pressUserData?.passType,
                pressPassType: this.state.pressUserData && this.state.pressUserData?.pressPassType,
                passAccess: [],
                pressAppliedDiscountCode: null,
                fname: '',
                lname: '',
                companyName: '',
                attendingIndependently: false,
                jobTitle: '',
                secondaryEmail: '',
                assistantName: '',
                primaryPhone: '',
                primaryPhoneType: '',
                referredBy: this.state.pressUserData?.referredBy,
                nickName: '',
                bio: '',
                shortBio: '',
                instagramLink: '',
                facebookLink: '',
                accountBillingAddress: {
                    streetBilling: '',
                    addressLine2Billing: '',
                    cityBilling: '',
                    stateBilling: '',
                    zipBilling: '',
                    countryBilling: ''
                },
                mailAddress: {
                    street: '',
                    addressLine2: '',
                    city: '',
                    state: '',
                    zip: '',
                    country: 'Select From Below'
                },

                festivalInfo: {
                    accessibilityNeed: [],
                    otherAccessibilityNeed: '',
                    attendLocation: "",
                    interestedIn: [],
                    favoriteFilm: '',
                    attended: ""
                },

                demoGraphicInfo: {
                    gender: '',
                    isTransGender: '',
                    raceOrigin: [],
                    otherRaceOrigin: '',
                    accommodationsEvent: [],
                    otherAccommodationsEvent: '',
                    industryAssociation: [],
                    otherIndustryAssociation: "",
                    sexualOrientation: '',
                    isPersonDisability: [],
                    otherIsPersonDisability:'',
                    artistCarerStage: '',
                    bornCountry: '',
                    bornYear: '',
                    education: ''
                },
                collab: {
                    primaryInterest: '',
                    secondaryInterest: []
                }
            }
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const allData = this.state.pressUserData;

        if (this.validator.allValid() && allData?.passAccess?.length > 0 && this.state.emailExistError === '' && this.state.isValidCode && this.state.jobTitleError === '' && this.state.companyNameError === '') {

            if ((allData?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Other') === 'Other' && allData?.demoGraphicInfo?.otherRaceOrigin === '') || (allData?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === 'Other') === 'Other' && allData?.demoGraphicInfo?.otherAccommodationsEvent === '') || (allData?.demoGraphicInfo?.industryAssociation?.find(_ => _ === 'Other') === 'Other' && allData?.demoGraphicInfo?.otherIndustryAssociation === '')  || (allData?.demoGraphicInfo?.isPersonDisability?.find(_ => _ === 'Other / Prefer to describe') === 'Other / Prefer to describe' && allData?.demoGraphicInfo?.otherIsPersonDisability === '')) {
                if (allData?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Other') === 'Other' && allData?.demoGraphicInfo?.otherRaceOrigin === '') {
                    this.setState({
                        otherRaceOriginError: 'This field is required.'
                    })
                }
                if (allData?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === 'Other') === 'Other' && allData?.demoGraphicInfo?.otherAccommodationsEvent === '') {
                    this.setState({
                        otherAccommodationsEventError: 'This field is required.'
                    })
                }
                if (allData?.demoGraphicInfo?.industryAssociation?.find(_ => _ === 'Other') === 'Other' && allData?.demoGraphicInfo?.otherIndustryAssociation === '') {
                    this.setState({
                        otherIndustryAssociationError: 'This field is required.'
                    })
                }
                if (allData?.demoGraphicInfo?.isPersonDisability?.find(_ => _ === 'Other / Prefer to describe') === 'Other / Prefer to describe' && allData?.demoGraphicInfo?.otherIsPersonDisability === '') {
                    this.setState({
                        otherIsPersonDisabilityError: 'This field is required.'
                    })
                }
                this.setState({ messageModal: true })
                this.ErrorScroll()
                return
            }

            if (this.state.otherRaceOriginError || this.state.otherAccommodationsEventError || this.state.otherIndustryAssociationError || this.state.otherIsPersonDisabilityError ) {
                this.setState({ messageModal: true })
                this.ErrorScroll()
                return
            }

            this.setState({ dataLoader: true })

            if (this.state.pressUserData?._id) {
                var data = this.state.pressUserData

                if (this.state.pressUserData?._id !== 'id')
                    data.userId = this.state.pressUserData?._id

                delete data['_id']
                delete data['id']


                // if(data?.purchaseStatus === 'complete' || data?.status === "pendingPass")
                // {
                //     delete data['passType']
                // }
                delete data['status']
                delete data['purchaseStatus']
                delete data['pressStatus']
                delete data['pressPurchaseStatus']
                delete data['isGuest']
                if (!data?.membershipExpirationDate) delete data['membershipExpirationDate'];
                this.apiserve.sendevent("admin|updateUser", data);
            }
            else {
                const createData = { ...this.state.pressUserData };
                if (!createData.membershipExpirationDate) delete createData['membershipExpirationDate'];
                this.apiserve.sendevent("admin|createUser", createData);
            }
        }
        else {
            this.setState({
                messageModal: true
            })
            this.validator.showMessages();
            allData?.passAccess?.length === 0 && this.setState({ passError: true })
            this.forceUpdate();
            this.ErrorScroll();
        }
    }

    getUserData = (userId, allSearch) => {
        var data = {
            userId: userId,
            allSearch: allSearch,
            adminRole:this.props.roleWise
        }
        this.setState({ for: 'Edit' })
        setTimeout(() => {
            this.apiserve.sendevent("admin|getUser", data);
        },500)
    }

    CloseModal = () => {
        // this.clear();
        this.props.CloseModal()
    }

    multiSelectCheck = (e) => {
        const { name, value, checked } = e.target;

        if (name === 'interestedIn' || name === 'accessibilityNeed' || name === "secondaryInterest") {
            var oldData = this.state.pressUserData?.festivalInfo?.accessibilityNeed;

            if (name === 'secondaryInterest')
                oldData = this.state.pressUserData?.collab?.secondaryInterest;

            if (name === 'interestedIn')
                oldData = this.state.pressUserData?.festivalInfo?.interestedIn;

            if (checked) {
                oldData.push(value)
            }
            else {
                oldData = oldData.filter(_ => _ !== value)
            }

            if (name === "secondaryInterest") {
                this.updateState({
                    pressUserData: {
                        ...this.state.pressUserData,
                        collab: {
                            ...this.state.pressUserData.collab,
                            [name]: oldData
                        }
                    }
                })
            } else {
                this.updateState({
                    pressUserData: {
                        ...this.state.pressUserData,
                        festivalInfo: {
                            ...this.state.pressUserData.festivalInfo,
                            [name]: oldData
                        }
                    }
                })
            }
        }
        if (name === 'raceOrigin') {
            var raceOrigin = [...(this.state.pressUserData?.demoGraphicInfo?.raceOrigin || [])];

            if (checked && value === "Other") {
                raceOrigin = ["Other"]
            } else if (checked) {
                if (raceOrigin.includes("Other")) {
                    var index = raceOrigin.indexOf("Other")
                    if (index > -1) {
                        raceOrigin.splice(index, 1)
                        this.state.pressUserData.demoGraphicInfo.otherRaceOrigin = ''
                    }
                }
                raceOrigin.push(value);
            } else {
                raceOrigin = raceOrigin.filter((_) => _ !== value);
                if (value === "Other") {
                    this.state.pressUserData.demoGraphicInfo.otherRaceOrigin = ''
                    this.updateState({ otherRaceOriginError:'' })
                }
            }
      
            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: raceOrigin,
                    },
                },
            });
        }
        if (name === 'isPersonDisability') {
            var isPersonDisability = [...(this.state.pressUserData?.demoGraphicInfo?.isPersonDisability || [])];
            if (checked && value === "Other / Prefer to describe") {
                isPersonDisability = ["Other / Prefer to describe"]
            } else if (checked && value === "No") {
                isPersonDisability = ["No"]
            } else if (checked && value === "Prefer not to say") {
                isPersonDisability = ["Prefer not to say"]
            } else if (checked) {
                if (isPersonDisability.includes("Other / Prefer to describe")) {
                    var index = isPersonDisability.indexOf("Other / Prefer to describe")
                    if (index > -1) {
                        isPersonDisability.splice(index, 1)
                        this.state.pressUserData.demoGraphicInfo.otherIsPersonDisability = ''
                    }
                }
                if (isPersonDisability.includes("Prefer not to say")) {
                    var index = isPersonDisability.indexOf("Prefer not to say")
                    if (index > -1) {
                        isPersonDisability.splice(index, 1)
                    }
                }
                if (isPersonDisability.includes("No")) {
                    var index = isPersonDisability.indexOf("No")
                    if (index > -1) {
                        isPersonDisability.splice(index, 1)
                    }
                }
                isPersonDisability.push(value);
            } else {
                isPersonDisability = isPersonDisability.filter((_) => _ !== value);
                if (value === "Other / Prefer to describe") {
                    this.state.pressUserData.demoGraphicInfo.otherIsPersonDisability = ''
                    this.updateState({ otherIsPersonDisabilityError:'' })
                }
            }

            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: isPersonDisability,
                    },
                },
            });
        }
        if (name === 'accommodationsEvent') {
            var accommodationsEvent = [...(this.state.pressUserData?.demoGraphicInfo?.accommodationsEvent || [])];

            if (checked && value === "None") {
                accommodationsEvent = ["None"]
            } else if (checked) {
                // if (accommodationsEvent.includes("Other")) {
                //     var index = accommodationsEvent.indexOf("Other")
                //     if (index > -1) {
                //         accommodationsEvent.splice(index, 1)
                //         this.state.pressUserData.demoGraphicInfo.otherAccommodationsEvent = ''
                //     }
                // }
                accommodationsEvent = accommodationsEvent.filter(_ => _ !== 'None');
                accommodationsEvent.push(value);
            } else {
                accommodationsEvent = accommodationsEvent.filter((_) => _ !== value);
                if (value === "Other") {
                    this.state.pressUserData.demoGraphicInfo.otherAccommodationsEvent = ''
                    this.updateState({otherAccommodationsEventError:''})
                }
            }

            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: accommodationsEvent,
                    },
                },
            });
        }
        if (name === 'industryAssociation') {
            var industryAssociation = [...(this.state.pressUserData?.demoGraphicInfo?.industryAssociation || [])];

            if (checked && value === "None") {
                industryAssociation = ["None"]
            } else if (checked) {
                // if (industryAssociation.includes("Other")) {
                //     var index = industryAssociation.indexOf("Other")
                //     if (index > -1) {
                //         industryAssociation.splice(index, 1)
                //         this.state.pressUserData.demoGraphicInfo.otherIndustryAssociation = ''
                //     }
                // }
                industryAssociation = industryAssociation.filter(_ => _ !== 'None');
                industryAssociation.push(value);
            } else {
                industryAssociation = industryAssociation.filter((_) => _ !== value);
                if (value === "Other") {
                    this.state.pressUserData.demoGraphicInfo.otherIndustryAssociation = ''
                    this.updateState({otherIndustryAssociationError:''})
                }
            }

            this.updateState({
                pressUserData: {
                    ...this.state.pressUserData,
                    demoGraphicInfo: {
                        ...this.state.pressUserData.demoGraphicInfo,
                        [name]: industryAssociation,
                    },
                },
            });
        }
    }
    handleAllAccessPassCheck = (e) => {
        const { id, name, checked } = e.target;
        var passData = this.state.pressUserData?.passAccess || [];
        const checkedVal = this.state.passAcessType?.map(item => {
            if (item?.MainCategory?.identifier === id) {
                item.MainCategory.checked = !item?.MainCategory?.checked
                // if (item?.MainCategory?.checked) {
                //     passData = []
                // }
                item.SubCategory.map(sub => {
                    sub.checked = !item?.MainCategory?.checked ? false : true;
                    if (!item?.MainCategory?.checked) {
                        passData = passData.filter(_ => _ !== sub?.identifier);
                    } else {
                        if (!passData.includes(sub?.identifier) && sub?.globalSoldOut === false) {
                            passData = [...passData, sub?.identifier]
                        }
                    }
                })
            }

        })
        this.updateState({
            passAcessType: [...this.state.passAcessType],
            passError: !(passData.length > 0) ,
            pressUserData: {
                ...this.state.pressUserData,
                passAccess: passData
            }
        })
    }
    handleAllAccessChild = (e, type) => {
        const { id, checked } = e.target;
        const ischecked = { ...this.state };
        var passData = this.state.pressUserData?.passAccess || [];
        this.state.passAcessType.map(item => {
            var check_all = [];

            item.SubCategory.map(sub => {
                // if (!sub?.globalSoldOut) {
                if (item?.MainCategory?.identifier === type) {
                    if (sub?.identifier === id) {
                        sub.checked = !sub?.checked
                        passData = sub?.checked ? [...passData, id] : passData.filter(_ => _ !== id)
                    }
                }
                sub?.checked && check_all.push(sub?.name)

                // }
            })
            if (item.MainCategory?.identifier === type) {
                if (type === 'allAccessPass' && check_all.length === item?.SubCategory?.length) {
                    item.MainCategory.checked = !item?.MainCategory?.checked
                } else {
                    item.MainCategory.checked = false;
                }
            }
        })
        this.updateState({
            passAcessType: [...this.state.passAcessType],
            passError: !(passData.length > 0 ),
            pressUserData: {
                ...this.state.pressUserData,
                passAccess: passData,
                pressPassType:'Select from below'
            }
        })
    }
    getYears = () => {
        var years = ["Select From Below", "Prefer not to answer"];
        var startYear = 1900;
        const year = new Date().getFullYear();

        // for (var start = startYear; start <= year; start++) {
        //     years.push(start.toString());
        // }

        for (var start = year; start >= startYear; start--) {
            years.push(start.toString());
        }

        return years;
    };
    render() {
        this.validator.purgeFields();
        const { createuser, CloseModal } = this.props
        const pressUser = this.state.pressUserData;
        const primarPhoneType = ["Select From Below", "Mobile", "Home", "Work"]
        const countries = ["Prefer not to answer"].concat(this.props?.countries || []);
        const state =[
            "Select From Below","Alabama", "Alaska", "Arizona", "Arkansas", "Armed Forces Americas", "Armed Forces Europe", "Armed Forces Pacific", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Prefer Not to Answer", "Puerto Rico", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"]
        const bornYear = this.getYears();
        const collabPrimaryInterest = ["Select from below", "Writing", "Directing", "Producing", "Documentary"];
        const collabSeconderyInterest = ["Select from below", "Writing", "Directing", "Producing", "Documentary"];
        const artisticcareer = ["Select from below", "Early career: less than 7 years of experience, or working on first project", "Mid-career: 7 to 25 years of experience, or one or more completed projects", "Lifelong career: more than 25 years of experience, or a large body of work", "Prefer not to answer"];
        const education = ["Select from below", "High school or equivalent", "Some college", "AA, technical degree, or one- to two-year conservancy program", "BA, BS, BFA, or an equivalent bachelor’s degree", "MA, MS, MBA, MFA, or an equivalent master’s degree", "JD, MD, DDS, EdD, PhD, or a similar advanced degree", "Prefer not to answer"];
        return (
            <div className={`user_popup ${createuser ? "active" : null}`}>
                <span className="popup_overlay" onClick={this.CloseModal}></span>
                <div className="editaccount sundance_popup_detail box_shadow">
                    <div className="bg_white">
                        <div className="form_header text_center">
                            <h4 className="form_heading">{this.state.for ? 'Edit' : 'Create'} {this.props.roleWise === 'press' ? 'Press User' : 'Artist User'}</h4>
                            <span className="closePopup pointer" onClick={CloseModal}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.181396L5.94897 4.55825L1.70697 0.181396L0.292969 1.64035L4.53497 6.0172L0.292969 10.394L1.70697 11.853L5.94897 7.47615L10.192 11.853L11.606 10.394L7.36397 6.0172L11.606 1.64035L10.192 0.181396Z" fill="white" />
                                </svg>
                            </span>
                        </div>
                        <div className="editaccountinner">
                            <div className="selection_pass text_center">
                                <label className="pass_label">Assign Products</label>
                                <div className="assign_product">
                                    {this.state.passAcessType?.map(item =>
                                        item?.MainCategory?.show &&
                                        <>
                                        <CheckBox name={item?.MainCategory?.name} checked={(this.state.for ? this.state.allAccess?.every(item => pressUser?.passAccess?.includes(item)) : this.state.allAccess?.forEach(item => pressUser?.passAccess?.includes(item))) === true && item?.MainCategory?.identifier === 'allAccessPass' ?
                                                true : item?.MainCategory?.checked
                                        } disable={(pressUser?.pressPurchaseStatus === "complete") || ((pressUser?.pressPurchaseStatus === 'waiting' || pressUser?.pressPurchaseStatus === 'pending') && pressUser?.status === 'pendingConfirmation') || ((pressUser?.pressPurchaseStatus === 'pending' || pressUser?.pressPurchaseStatus === 'waiting') && pressUser?.status === 'confirmed') ? true : false} onChange={this.handleAllAccessPassCheck} label={item?.MainCategory?.name} type="CheckBox" id={item?.MainCategory?.identifier} />
                                        <div className="pl_15">
                                            {item?.SubCategory?.map(sub =>
                                                pressUser?.status !== 'confirmed' ?
                                                    !sub?.globalSoldOut &&
                                                    <>
                                                    <CheckBox name={sub?.name} checked={pressUser?.passAccess?.includes(sub?.identifier) ? true : sub?.checked} disable={pressUser?.pressPurchaseStatus === "complete" ? true : false} onChange={(e) => this.handleAllAccessChild(e, item?.MainCategory?.identifier)} label={sub?.name} type="CheckBox" id={sub?.identifier} />
                                                    </>
                                                    :
                                                    sub?.globalSoldOut && sub?.identifier !== pressUser?.pressPassType ?
                                                        '' :
                                                        <>
                                                        < CheckBox name={sub?.name} checked={pressUser?.passAccess?.includes(sub?.identifier) ? true : sub?.checked} disable={pressUser?.pressPurchaseStatus === "complete" ? true : false} onChange={(e) => this.handleAllAccessChild(e, item?.MainCategory?.identifier)} label={sub?.name} type="CheckBox" id={sub?.identifier} />
                                                        </>
                                            )}
                                        </div>
                                        </>
                                    )}
                                </div>
                                {this.state.passError && <span className="srv-validation-message" style={{ color: 'red' }}>Please assign a product to the user</span>}
                                <div className="d_flex d_flex_justify_center mt_15 pt_15">
                                    {this.state.complist?.map(item => {
                                        return (
                                            <div className={"mr_15"}>
                                                <CheckBox name={item?.identifier} checked={pressUser?.pressAppliedDiscountCode?.identifier === item?.identifier} disable={pressUser?.pressPurchaseStatus === "complete" ? true : false} onChange={(e) => this.handleCompCheck(e, item?.identifier)} label={item?.couponCode} type="CheckBox" id={item?._id}  />
                                            </div>
                                        )
                                    })}
                                    {!this.state.isValidCode && <div className="srv-validation-message" style={{ color: 'red',width:'100%',position: 'absolute',bottom: '10px',fontWeight: 900,letterSpacing: '0.8px' }}> {this.state.complist?.filter(_ => _.identifier === pressUser?.pressAppliedDiscountCode?.identifier)[0]?.couponCode} has expired.</div>}
                                </div>
                            </div>
                            <div className="user_profile radius_50 absolute_loader">
                                {
                                    this.state.imagePreloader ?
                                        <Loader /> :
                                        <img src={pressUser?.image ?
                                            (this.apiserve.imageUrl + pressUser?.image + '?' + (new Date().getTime())) :
                                            userPic
                                        } alt="user" />
                                }
                                <span className="add_profile pointer">
                                    <input type="file" onChange={this.ChangeProfile} />
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 8C16 10.1217 15.1571 12.1566 13.6569 13.6569C12.1566 15.1571 10.1217 16 8 16C5.87827 16 3.84344 15.1571 2.34315 13.6569C0.842855 12.1566 0 10.1217 0 8C0 5.87827 0.842855 3.84344 2.34315 2.34315C3.84344 0.842855 5.87827 0 8 0C10.1217 0 12.1566 0.842855 13.6569 2.34315C15.1571 3.84344 16 5.87827 16 8ZM8.5 4C8.5 3.86739 8.44732 3.74021 8.35355 3.64645C8.25979 3.55268 8.13261 3.5 8 3.5C7.86739 3.5 7.74021 3.55268 7.64645 3.64645C7.55268 3.74021 7.5 3.86739 7.5 4V7.5H4C3.86739 7.5 3.74021 7.55268 3.64645 7.64645C3.55268 7.74021 3.5 7.86739 3.5 8C3.5 8.13261 3.55268 8.25979 3.64645 8.35355C3.74021 8.44732 3.86739 8.5 4 8.5H7.5V12C7.5 12.1326 7.55268 12.2598 7.64645 12.3536C7.74021 12.4473 7.86739 12.5 8 12.5C8.13261 12.5 8.25979 12.4473 8.35355 12.3536C8.44732 12.2598 8.5 12.1326 8.5 12V8.5H12C12.1326 8.5 12.2598 8.44732 12.3536 8.35355C12.4473 8.25979 12.5 8.13261 12.5 8C12.5 7.86739 12.4473 7.74021 12.3536 7.64645C12.2598 7.55268 12.1326 7.5 12 7.5H8.5V4Z" fill="#2F86C6" />
                                    </svg>
                                </span>
                                <div
                                    className="sundance-sdk"
                                    data-componentname="ImageUpload"
                                    data-view="button"
                                    data-file-accept="image/jpeg,image/png"
                                    data-max-file-size-limit-text="10 MB"
                                    data-max-file-ratio-limit="1:1"
                                    data-max-file-resolution-limit="150x150"
                                    data-title="Add a profile photo"
                                    data-description="false"
                                    data-folderpath=""
                                    data-filename={this.getProfileFilename()}
                                    >
                                </div>
                            </div>
                        </div>
                        <div className="editaccountinner">
                            <form>
                                <div className="editcontentBox">
                                    <div className="editBoxheading">
                                        <p className="">General Information</p>
                                        <span class="d_block sd_common_note">Note: The information you provide—Name, Organization, Job Title and Photo—will be printed on your festival credential.</span>
                                    </div>
                                    <div className="form_inner">
                                        <form>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='email' onChange={this.handleEmailText} value={pressUser?.email} label="Email" type="text" require="require" maxLength={255} />
                                                    <span style={{ color: 'red' }}>{this.validator.message('email', pressUser?.email, 'required|email|max:255')}</span>
                                                    {this.state.emailExistError !== '' && <span style={{ color: 'red' }}><div className='srv-validation-message'>{this.state.emailExistError}</div></span>}
                                                </div>
                                                {/* <div className="field_row">
                                                    <TextField label="Referred By" type="text" placeholder="Robert Redford" />
                                                </div> */}
                                                {pressUser?.referredBy &&
                                                    <div className="field_row">
                                                        <TextField
                                                            value={pressUser?.referredBy}
                                                            label="Referred By"
                                                            type="text"
                                                            disable="disabled"
                                                        />
                                                    </div>
                                                }
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='fname' onChange={this.handleText} value={pressUser?.fname} label="First Name" require="require" type="text" placeholder="" maxLength={100} />
                                                    <span style={{ color: 'red' }}>{this.validator.message('first name', pressUser?.fname, 'required|max:100')}</span>
                                                </div>
                                                <div className="field_row">
                                                    <TextField name='lname' onChange={this.handleText} value={pressUser?.lname} label="Last Name" require="require" type="text" placeholder="" maxLength={100} />
                                                    <span style={{ color: 'red' }}>{this.validator.message('last name', pressUser?.lname, 'required|max:100')}</span>
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='nickName' onChange={this.handleText} value={pressUser?.nickName} label="Nickname" type="text" />
                                                </div>
                                            </div>
                                            <div className="two_fields d_flex_align_center">
                                                <div className="field_row">
                                                    <TextField name='companyName' onChange={this.handleText} value={pressUser?.companyName} label="Company/Organization  Name" type="text" placeholder="" />
                                                    {this.state.companyNameError !== '' && <span style={{ color: 'red' }}><div class="srv-validation-message">{this.state.companyNameError}</div></span>}
                                                </div>
                                                <div className="field_row">
                                                    <label>&nbsp;</label>
                                                    <label>&nbsp;</label>
                                                    <CheckBox name='attendingIndependently' checked={pressUser?.attendingIndependently} onChange={this.handleCheck} type="checkbox" label="Attending Independently" id="attending" />
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='jobTitle' onChange={this.handleText} value={pressUser?.jobTitle} label="Job Title" type="text" placeholder="" />
                                                    {this.state.jobTitleError !== '' && <span style={{ color: 'red' }}><div class="srv-validation-message">{this.state.jobTitleError}</div></span>}
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='secondaryEmail' onChange={this.handleText} value={pressUser?.secondaryEmail} label="Secondary/Assistant Email" type="text" />
                                                    <span style={{ color: 'red' }}>{this.validator.message('secondaryEmail', pressUser?.secondaryEmail, 'email')}</span>
                                                </div>
                                                <div className="field_row">
                                                    <TextField name='assistantName' onChange={this.handleText} value={pressUser?.assistantName} label="Assistant Name" type="text" placeholder="" />
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='primaryPhone' onChange={this.handleText} value={pressUser?.primaryPhone} label="Phone" type="text" placeholder="" />
                                                    <span style={{ color: 'red' }}>{this.validator.message('phone', pressUser?.primaryPhone, 'phone')}</span>
                                                </div>
                                                <div className="field_row">
                                                    <TextField pattern="[0-9]*" name='extPhone' onChange={this.handleText} value={pressUser?.extPhone} label="EXT" type="text" placeholder="" />
                                                </div>
                                                <div className="field_row">
                                                    <DropDown name='primaryPhoneType' options={primarPhoneType} onChange={this.handleText} value={pressUser?.primaryPhoneType} label="Phone Type" />
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <Textarea name='bio' onChange={this.handleText} value={pressUser?.bio} label="Bio" type="text" />
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <Textarea name='shortBio' onChange={this.handleText} value={pressUser?.shortBio} label="Short Bio" type="text" />
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='instagramLink' onChange={this.handleText} value={pressUser?.instagramLink} label="InstagramLink" type="text" />
                                                </div>
                                            </div>
                                            <div className="two_fields">
                                                <div className="field_row">
                                                    <TextField name='facebookLink' onChange={this.handleText} value={pressUser?.facebookLink} label="FacebookLink" type="text" />
                                                </div>
                                            </div>
                                            <div>
                                                <h5 className="heading_fields">Billing Address  </h5>
                                                <div className="address_row two_fields">
                                                    <div className="field_row">
                                                        <TextField name='streetBilling' onChange={this.handleText} value={pressUser ?.accountBillingAddress ?.streetBilling} label="Street address 1" type="text" placeholder="" />
                                                    </div>
                                                    <div className="field_row">
                                                        <TextField name='addressLine2Billing' onChange={this.handleText} value={pressUser ?.accountBillingAddress ?.addressLine2Billing} label="Street address 2" type="text" placeholder="" />
                                                    </div>
                                                    <div className="field_row city_field">
                                                        <TextField name='cityBilling' onChange={this.handleText} value={pressUser ?.accountBillingAddress ?.cityBilling} label="City" type="text" placeholder="" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="address_row two_fields">
                                                <div className="field_row state_field">
                                                    <TextField name='stateBilling' onChange={this.handleText} value={pressUser ?.accountBillingAddress ?.stateBilling} label="State/Province" type="text" placeholder="" />
                                                </div>
                                                <div className="field_row zipcod_field">
                                                    <TextField name='zipBilling' onChange={this.handleText} value={pressUser ?.accountBillingAddress ?.zipBilling} label="Zip/Postal Code" type="text" placeholder="" />
                                                </div>
                                                <div className="field_row phone_field">
                                                    <DropDown name='countryBilling' options={countries} onChange={this.handleText} value={pressUser ?.accountBillingAddress ?.countryBilling} label="Country" />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="disp_flex">
                                                    <h5 className="heading_fields mr_10">Mailing Address</h5>
                                                    <CheckBox label="Same as Billing" id="sameas" onChange={this.copyAddress} type="checkbox" checked={this.state.sameAs} />
                                                </div>
                                                <div className="address_row two_fields">
                                                    <div className="field_row">
                                                        <TextField name='street' onChange={this.handleText} value={pressUser?.mailAddress?.street} label="Street address 1" type="text" placeholder="" />
                                                    </div>
                                                    <div className="field_row">
                                                        <TextField name='addressLine2' onChange={this.handleText} value={pressUser?.mailAddress?.addressLine2} label="Street address 2" type="text" placeholder="" />
                                                    </div>
                                                    <div className="field_row city_field">
                                                        <TextField name='city' onChange={this.handleText} value={pressUser?.mailAddress?.city} label="City" type="text" placeholder="" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="address_row two_fields">
                                                <div className="field_row state_field">
                                                    <TextField name='state' onChange={this.handleText} value={pressUser?.mailAddress?.state} label="State/Province" type="text" placeholder="" />
                                                </div>
                                                <div className="field_row zipcod_field">
                                                    <TextField name='zip' onChange={this.handleText} value={pressUser?.mailAddress?.zip} label="Zip/Postal Code" type="text" placeholder="" />
                                                </div>
                                                <div className="field_row phone_field">
                                                    <DropDown name='country' options={countries} onChange={this.handleText} value={pressUser?.mailAddress?.country} label="Country" />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="editcontentBox">
                                    <div className="editBoxheading">
                                        <p className="editBoxheading">Festival Details</p>
                                    </div>
                                    <div className="form_inner">
                                        <form>
                                            <div className="check_question d_none">
                                                <label className="chk_qustion_title">Please share your accessibility needs</label>
                                                <CheckBox name='accessibilityNeed' checked={pressUser?.festivalInfo?.accessibilityNeed?.find(_ => _ === 'Closed Captioning') === 'Closed Captioning' ? true : false} onChange={this.multiSelectCheck} value='Closed Captioning' label="Closed Captioning" type="checkbox" id="captioning" />
                                                <CheckBox name='accessibilityNeed' checked={pressUser?.festivalInfo?.accessibilityNeed?.find(_ => _ === 'Audio Description') === 'Audio Description' ? true : false} onChange={this.multiSelectCheck} value='Audio Description' label="Audio Description" type="checkbox" id="audioDesc" />
                                                <CheckBox name='accessibilityNeed' checked={pressUser?.festivalInfo?.accessibilityNeed?.find(_ => _ === 'Other') === 'Other' ? true : false} onChange={this.multiSelectCheck} value='Other' label="Other" type="checkbox" id="other" />

                                                {
                                                    pressUser?.festivalInfo?.accessibilityNeed?.find(_ => _ === 'Other') === 'Other' ?

                                                        <div className="two_fields inner_check_question">
                                                            <div className="field_row">
                                                                <TextField name='otherAccessibilityNeed' onChange={this.handleText} value={pressUser?.festivalInfo?.otherAccessibilityNeed} />
                                                                {/* <span style={{color : 'red'}}>{this.state.otherAccessibilityNeedError}</span> */}
                                                            </div>
                                                        </div> : ''
                                                }

                                            </div>
                                            <div className="check_question">
                                                <div className="two_fields two_fields_full">
                                                    <div className="field_row number_field">
                                                        <TextField name='attended' onChange={this.handleText} value={pressUser?.festivalInfo?.attended} label="How many Sundance Film Festivals have you attended?" type="text" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">Which of Sundance Institute Artist Support programs are you interested in?</label>
                                                <div className="d_flex three_col_check">
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Documentary Film Program') === 'Documentary Film Program' ? true : false} value='Documentary Film Program' onChange={this.multiSelectCheck} label="Documentary Film Program" type="checkbox" id="circle_Documentary" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Creative Producing Program') === 'Creative Producing Program' ? true : false} value='Creative Producing Program' onChange={this.multiSelectCheck} label="Creative Producing Program" type="checkbox" id="circle_Creative" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Women At Sundance Program') === 'Women At Sundance Program' ? true : false} value='Women At Sundance Program' onChange={this.multiSelectCheck} label="Women At Sundance Program" type="checkbox" id="circle_Women" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Feature Film Program') === 'Feature Film Program' ? true : false} value='Feature Film Program' onChange={this.multiSelectCheck} label="Feature Film Program" type="checkbox" id="circle_Feature" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Episodic Program') === 'Episodic Program' ? true : false} value='Episodic Program' onChange={this.multiSelectCheck} label="Episodic Program" type="checkbox" id="circle_Episodic" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Outreach & Inclusion Program') === 'Outreach & Inclusion Program' ? true : false} value='Outreach & Inclusion Program' onChange={this.multiSelectCheck} label="Outreach & Inclusion Program" type="checkbox" id="circle_Outreach" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Interdisciplinary Program: Film Music, New Frontier, Theater') === 'Interdisciplinary Program: Film Music, New Frontier, Theater' ? true : false} value='Interdisciplinary Program: Film Music, New Frontier, Theater' onChange={this.multiSelectCheck} label="Interdisciplinary Program: Film Music, New Frontier, Theater" type="checkbox" id="circle_FilmMusic" />
                                                    {/* <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_=>_ === 'Creative Producing Program') === 'Creative Producing Program' ? true : false} value='Creative Producing Program' onChange={this.multiSelectCheck} label="Creative Producing Program" type="checkbox" id="circle_Producing"/> */}
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Short Film Program') === 'Short Film Program' ? true : false} value='Short Film Program' onChange={this.multiSelectCheck} label="Short Film Program" type="checkbox" id="circle_Frontier" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Ignite Program') === 'Ignite Program' ? true : false} value='Ignite Program' onChange={this.multiSelectCheck} label="Ignite Program" type="checkbox" id="circle_Ignite" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Indigenous Program') === 'Indigenous Program' ? true : false} value='Indigenous Program' onChange={this.multiSelectCheck} label="Indigenous Program" type="checkbox" id="circle_Indigenous" />
                                                    <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_ => _ === 'Catalyst Program') === 'Catalyst Program' ? true : false} value='Catalyst Program' onChange={this.multiSelectCheck} label="Catalyst Program" type="checkbox" id="circle_Catalyst" />
                                                    {/* <CheckBox name='interestedIn' checked={pressUser?.festivalInfo?.interestedIn?.find(_=>_ === 'Theatre Program') === 'Theatre Program' ? true : false} value='Theatre Program' onChange={this.multiSelectCheck} label="Theatre Program" type="checkbox" id="circle_Theatre"/> */}
                                                </div>
                                            </div>
                                            <div className="d_flex_align_center">
                                                <div className="field_row w_50">
                                                    <TextField name='favoriteFilm' value={pressUser?.festivalInfo?.favoriteFilm} onChange={this.handleText} label="What is your favorite Sundance Film Festival film?" type="text" placeholder="" />
                                                    {/* <span style={{color : 'red'}}>{this.validator.message('', circleUser.companyName, 'required')}</span> */}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="editcontentBox">
                                    <div className="editBoxheading">
                                        <p className="editBoxheading">Demographic Information</p>
                                    </div>
                                    <div className='demographic_subheading'>
                                        <p>The Sundance Institute is continuously looking to improve the experience of our programs. As part of our ongoing commitment to accessibility and equity in the Festival experience and in our public and artist programs, your participation in this survey is appreciated. Please note that you may select “prefer not to answer” for any question.</p>
                                        <p>This information will be used by Sundance Institute to improve the Festival experience. It may be shared with third parties in aggregate (anonymous) form. Thank you for contributing to our efforts to ensure equity across our programs.</p>
                                        <p>Please select your answers from the drop-downs below each question.</p>
                                    </div>
                                    <div className="form_inner">
                                        <form>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">What is your gender expression?</label>
                                                <div className="d_flex d_flex_align_center">
                                                    <CheckBox name='gender' checked={pressUser?.demoGraphicInfo?.gender === 'Woman' ? true : false} value='Woman' onChange={this.handleUncheck} label="Woman" type="checkbox" id="Woman" />
                                                    <CheckBox name='gender' checked={pressUser?.demoGraphicInfo?.gender === 'Man' ? true : false} value='Man' onChange={this.handleUncheck} label="Man" type="checkbox" id="Man" />
                                                    <CheckBox name='gender' checked={pressUser?.demoGraphicInfo?.gender === 'Nonbinary or Gender Nonconforming' ? true : false} value='Nonbinary or Gender Nonconforming' onChange={this.handleUncheck} label="Nonbinary or Gender Nonconforming" type="checkbox" id="Nonbinary" />
                                                    <CheckBox name='gender' checked={pressUser?.demoGraphicInfo?.gender === 'Intersex' ? true : false} value='Intersex' onChange={this.handleUncheck} label="Intersex" type="checkbox" id="Intersex" />
                                                    <CheckBox name='gender' checked={pressUser?.demoGraphicInfo?.gender === '2Spirit' ? true : false} value='2Spirit' onChange={this.handleUncheck} label="2Spirit" type="checkbox" id="2Spirit" />
                                                    <CheckBox name='gender' checked={pressUser?.demoGraphicInfo?.gender === 'Other' ? true : false} value='Other' onChange={this.handleUncheck} label="Other" type="checkbox" id="Other" />
                                                    <CheckBox name='gender' checked={pressUser?.demoGraphicInfo?.gender === 'Prefer not to answer' ? true : false} value='Prefer not to answer' onChange={this.handleUncheck} label="Prefer not to answer" type="checkbox" id="noanswer" />
                                                </div>
                                            </div>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">Do you identify as transgender?</label>
                                                <div className="d_flex d_flex_align_center">
                                                    <CheckBox name='isTransGender' checked={pressUser?.demoGraphicInfo?.isTransGender === 'Yes' ? true : false} value='Yes' onChange={this.handleUncheck} label="Yes" type="checkbox" id="transgenderY" />
                                                    <CheckBox name='isTransGender' checked={pressUser?.demoGraphicInfo?.isTransGender === 'No' ? true : false} value='No' onChange={this.handleUncheck} label="No" type="checkbox" id="transgenderN" />
                                                    <CheckBox name='isTransGender' checked={pressUser?.demoGraphicInfo?.isTransGender === 'Prefer not to answer' ? true : false} value='Prefer not to answer' onChange={this.handleUncheck} label="Prefer not to answer" type="checkbox" id="TransNo" />
                                                </div>
                                            </div>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">What is your race and/or ethnic origin? Check all that apply</label>
                                                <div className="d_flex two_col_check">
                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Asian, South Asian, Southeast Asian, or East Asian') === 'Asian, South Asian, Southeast Asian, or East Asian' ? true : false} value='Asian, South Asian, Southeast Asian, or East Asian' onChange={this.multiSelectCheck} label="Asian, South Asian, Southeast Asian, or East Asian" type="checkbox" id="race1" />
                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Black, African American, or of African descent') === 'Black, African American, or of African descent' ? true : false} value='Black, African American, or of African descent' onChange={this.multiSelectCheck} label="Black, African American, or of African descent" type="checkbox" id="race2" />
                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'White, European, or of European descent') === 'White, European, or of European descent' ? true : false} value='White, European, or of European descent' onChange={this.multiSelectCheck} label="White, European, or of European descent" type="checkbox" id="race3" />
                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Hispanic, Latino/a, Latinx, Latine') === 'Hispanic, Latino/a, Latinx, Latine' ? true : false} value='Hispanic, Latino/a, Latinx, Latine' onChange={this.multiSelectCheck} label="Hispanic, Latino/a, Latinx, Latine" type="checkbox" id="race4" />
                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Middle Eastern') === 'Middle Eastern' ? true : false} value='Middle Eastern' onChange={this.multiSelectCheck} label="Middle Eastern" type="checkbox" id="race5" />
                                                    {/* <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'White') === 'White' ? true : false} value='White' onChange={this.multiSelectCheck} label="White" type="checkbox" id="race7" /> */}
                                                    {/* <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'DeclinDemographic Informatione to State') === 'Decline to State' ? true : false} value='Decline to State' onChange={this.multiSelectCheck} label="Decline to State" type="checkbox" id="race7" /> */}
                                                    

                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Native American, First Nations, or Indigenous') === 'Native American, First Nations, or Indigenous' ? true : false} value='Native American, First Nations, or Indigenous' onChange={this.multiSelectCheck} label="Native American, First Nations, or Indigenous" type="checkbox" id="race8" />
                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Pacific Islander and/or Native Hawaiian') === 'Pacific Islander and/or Native Hawaiian' ? true : false} value='Pacific Islander and/or Native Hawaiian' onChange={this.multiSelectCheck} label="Pacific Islander and/or Native Hawaiian" type="checkbox" id="race9" />
                                                    {/* <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Caucasian/White') === 'Caucasian/White' ? true : false} value='Caucasian/White' onChange={this.multiSelectCheck} label="Caucasian/White" type="checkbox" id="race11" /> */}
                                                    <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Prefer not to answer') === 'Prefer not to answer' ? true : false} value='Prefer not to answer' onChange={this.multiSelectCheck} label="Prefer not to answer" type="checkbox" id="race10" />
                                                    <div className='checkbox_field_row'>
                                                        <CheckBox name='raceOrigin' checked={pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Other') === 'Other' ? true : false} value='Other' onChange={this.multiSelectCheck} label="Other" type="checkbox" id="race6" />
                                                        {
                                                            pressUser?.demoGraphicInfo?.raceOrigin?.find(_ => _ === 'Other') === 'Other' ?

                                                                <div className="two_fields field_row inner_check_question">
                                                                    <div className="field_row">
                                                                        <TextField name='otherRaceOrigin' onChange={this.handleText} value={pressUser?.demoGraphicInfo?.otherRaceOrigin} />
                                                                        {this.state.otherRaceOriginError !== '' ? <div className='srv-validation-message' style={{ color: 'red' }}>{this.state.otherRaceOriginError}</div> : <span style={{ color: "red" }}> {this.validator.message("otherRaceOrigin", pressUser?.demoGraphicInfo?.otherRaceOrigin, "Required")}</span>}
                                                                    </div>
                                                                </div> : ''
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">How would you define your sexual orientation?</label>
                                                <div className="d_flex d_flex_align_center">
                                                    <CheckBox name='sexualOrientation' checked={pressUser?.demoGraphicInfo?.sexualOrientation === 'Heterosexual' ? true : false} value='Heterosexual' onChange={this.handleUncheck} label="Heterosexual" type="checkbox" id="Heterosexual" />
                                                    <CheckBox name='sexualOrientation' checked={pressUser?.demoGraphicInfo?.sexualOrientation === 'Gay or Lesbian' ? true : false} value='Gay or Lesbian' onChange={this.handleUncheck} label="Gay or Lesbian" type="checkbox" id="gaylasbian" />
                                                    <CheckBox name='sexualOrientation' checked={pressUser?.demoGraphicInfo?.sexualOrientation === 'Bisexual and/or Pansexual' ? true : false} value='Bisexual and/or Pansexual' onChange={this.handleUncheck} label="Bisexual and/or Pansexual" type="checkbox" id="Bisexual and/or Pansexual" />
                                                    <CheckBox name='sexualOrientation' checked={pressUser?.demoGraphicInfo?.sexualOrientation === 'Other' ? true : false} value='Other' onChange={this.handleUncheck} label="Other" type="checkbox" id="sexualOther" />
                                                    <CheckBox name='sexualOrientation' checked={pressUser?.demoGraphicInfo?.sexualOrientation === 'Prefer not to answer' ? true : false} value='Prefer not to answer' onChange={this.handleUncheck} label="Prefer not to answer" type="checkbox" id="prefnoanswer" />
                                                </div>
                                            </div>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">Do you identify as a person with a disability? Check all that apply</label>
                                                <div className="d_flex d_flex_align_center">
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Autism / Neurodivergent" ) === "Autism / Neurodivergent" ? true : false } value="Autism / Neurodivergent" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Autism / Neurodivergent" id="AutismNeurodivergent" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Blind or low vision" ) === "Blind or low vision" ? true : false } value="Blind or low vision" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Blind or low vision" id="Blindorlowvision" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Cognitive disability" ) === "Cognitive disability" ? true : false } value="Cognitive disability" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Cognitive disability" id="Cognitivedisability" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Chronic illness / pain" ) === "Chronic illness / pain" ? true : false } value="Chronic illness / pain" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Chronic illness / pain" id="Chronicillnesspain" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "d/Deaf or hard of hearing" ) === "d/Deaf or hard of hearing" ? true : false } value="d/Deaf or hard of hearing" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="d/Deaf or hard of hearing" id="deaforhardofhearing" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Developmental disability" ) === "Developmental disability" ? true : false } value="Developmental disability" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Developmental disability" id="Developmentaldisability" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Learning / Behavioral disability" ) === "Learning / Behavioral disability" ? true : false } value="Learning / Behavioral disability" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Learning / Behavioral disability" id="LearningBehavioraldisability" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Mental health condition" ) === "Mental health condition" ? true : false } value="Mental health condition" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Mental health condition" id="Mentalhealthcondition" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Physical disability" ) === "Physical disability" ? true : false } value="Physical disability" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Physical disability" id="Physicaldisability" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Speech-related disability" ) === "Speech-related disability" ? true : false } value="Speech-related disability" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Speech-related disability" id="Speechrelateddisability" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Other / Prefer to describe" ) === "Other / Prefer to describe" ? true : false } value="Other / Prefer to describe" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Other / Prefer to describe" id="OtherPrefertodescribe" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "No" ) === "No" ? true : false } value="No" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="No" id="Prefernottosay" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Prefer not to say" ) === "Prefer not to say" ? true : false } value="Prefer not to say" onChange={this.multiSelectCheck} type="checkbox" name="isPersonDisability" label="Prefer not to say" id="Prefernottosay" />
                                                    {pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Other / Prefer to describe" ) === "Other / Prefer to describe" && (
                                                        <div className="two_fields field_row inner_check_question">
                                                            <div className="field_row">
                                                                <TextField readonly={this.state.readonlyText} name="otherIsPersonDisability" onChange={this.handleText} value={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.otherIsPersonDisability } />
                                                                {pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.isPersonDisability?.find( (_) => _ === "Other / Prefer to describe" ) === "Other / Prefer to describe" ? (
                                                                    this.state.otherIsPersonDisabilityError !== '' ? <span style={{ color: 'red' }} className="srv-validation-message">{this.state.otherIsPersonDisabilityError}</span> : <span style={{ color: "red" }}> {this.validator.message("otherIsPersonDisability", pressUser?.demoGraphicInfo?.otherIsPersonDisability, "Required")}</span>
                                                                    ) : ( "" )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">Which accommodations are often helpful to your engagement at other events? Check all that apply.</label>
                                                <span className='chk_qustion_title'>Note: This is a demographic survey. If you need accommodation(s) for select screenings, contact <a href="mailto:accessibility@sundance.org">accessibility@sundance.org</a></span>
                                                <div className="d_flex two_col_check">
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "None") === 'None' ? true : false } value="None" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="None" id="accommondationNone" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "American Sign Language - English interpretation") === 'American Sign Language - English interpretation' ? true : false } value="American Sign Language - English interpretation" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="American Sign Language - English interpretation" id="americanSignEnglishInterpretation" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Assistive Listening Devices") === "Assistive Listening Devices" ? true : false } value="Assistive Listening Devices" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Assistive Listening Devices" id="assistiveListeningDevices" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Open Captioning") === "Open Captioning" ? true : false } value="Open Captioning" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Open Captioning" id="openCaptioning" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Closed Captioning") === "Closed Captioning" ? true : false } value="Closed Captioning" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Closed Captioning" id="closedCaptioning" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Live or Real-Time Captioning (CART) of speakers, discussions, and Q&As") === "Live or Real-Time Captioning (CART) of speakers, discussions, and Q&As" ? true : false } value="Live or Real-Time Captioning (CART) of speakers, discussions, and Q&As" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Live or Real-Time Captioning (CART) of speakers, discussions, and Q&As" id="liveOrRealtimeCaptioning" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Transcripts of conversations (live or recorded)") === "Transcripts of conversations (live or recorded)" ? true : false } value="Transcripts of conversations (live or recorded)" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Transcripts of conversations (live or recorded)" id="transcriptsofconversations" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Audio Description") === "Audio Description" ? true : false } value="Audio Description" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Audio Description" id="audioDescription" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Visual descriptions of presentation materials, signage, and personal descriptions") === "Visual descriptions of presentation materials, signage, and personal descriptions" ? true : false } value="Visual descriptions of presentation materials, signage, and personal descriptions" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Visual descriptions of presentation materials, signage, and personal descriptions" id="visualDescriptions" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Large-print text") === "Large-print text" ? true : false } value="Large-print text" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Large-print text" id="largeprinttext" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Information available in Braille") === "Information available in Braille" ? true : false } value="Information available in Braille" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Information available in Braille" id="informationavailableinBraille" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Screen-reader access") === "Screen-reader access" ? true : false } value="Screen-reader access" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Screen-reader access" id="screenreaderaccess" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Accessible seating & companion seating") === "Accessible seating & companion seating" ? true : false } value="Accessible seating & companion seating" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Accessible seating & companion seating" id="Accessibleandcompanionseating" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "ADA-compliant ramps") === "ADA-compliant ramps" ? true : false } value="ADA-compliant ramps" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="ADA-compliant ramps" id="ADAcompliantramps" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "ADA bathrooms") === "ADA bathrooms" ? true : false } value="ADA bathrooms" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="ADA bathrooms" id="ADAbathrooms" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Self-provided personal support (medical aide, guide, etc.)") === "Self-provided personal support (medical aide, guide, etc.)" ? true : false } value="Self-provided personal support (medical aide, guide, etc.)" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Self-provided personal support (medical aide, guide, etc.)" id="selfprovidedpersonalsupport" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Festival-provided assistance (human guide, reader, etc.)") === "Festival-provided assistance (human guide, reader, etc.)" ? true : false } value="Festival-provided assistance (human guide, reader, etc.)" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Festival-provided assistance (human guide, reader, etc.)" id="festivalprovidedassistance" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Scheduled breaks and/or assigned rest areas") === "Scheduled breaks and/or assigned rest areas" ? true : false } value="Scheduled breaks and/or assigned rest areas" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Scheduled breaks and/or assigned rest areas" id="scheduledbreaksandrestareas" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Sensory-friendly screenings, programming, and assigned spaces") === "Sensory-friendly screenings, programming, and assigned spaces" ? true : false } value="Sensory-friendly screenings, programming, and assigned spaces" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Sensory-friendly screenings, programming, and assigned spaces" id="sensoryfriendlyscreenings" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === "Content warnings (photosensitivity, sensitive content, etc.)") === "Content warnings (photosensitivity, sensitive content, etc.)" ? true : false } value="Content warnings (photosensitivity, sensitive content, etc.)" onChange={this.multiSelectCheck} type="checkbox" name="accommodationsEvent" label="Content warnings (photosensitivity, sensitive content, etc.)" id="contentwarnings" />
                                                    <div className='checkbox_field_row'>
                                                        <CheckBox name='accommodationsEvent' checked={pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === 'Other') === 'Other' ? true : false} value='Other' onChange={this.multiSelectCheck} label="Other" type="checkbox" id="accommodationsEventOther" />
                                                        {
                                                            pressUser?.demoGraphicInfo?.accommodationsEvent?.find(_ => _ === 'Other') === 'Other' ?

                                                                <div className="two_fields field_row inner_check_question">
                                                                    <div className="field_row">
                                                                        <TextField name='otherAccommodationsEvent' onChange={this.handleText} value={pressUser?.demoGraphicInfo?.otherAccommodationsEvent} />
                                                                        {this.state.otherAccommodationsEventError !== '' ? <div className='srv-validation-message' style={{ color: 'red' }}>{this.state.otherAccommodationsEventError}</div> : <span style={{ color: "red" }}> {this.validator.message("otherAccommodationsEvent", pressUser?.demoGraphicInfo?.otherAccommodationsEvent, "Required")}</span>}
                                                                    </div>
                                                                </div> : ''
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="two_fields mb_10">
                                                <div className="field_row">
                                                    <DropDown name='artistCarerStage' options={artisticcareer} onChange={this.handleText} value={pressUser ?.demoGraphicInfo ?.artistCarerStage} label="What stage are you at in your artistic career?" />
                                                </div>
                                            </div> */}
                                            <div className="two_fields mb_10">
                                                <div className="field_row">
                                                    <DropDown name="bornYear" options={bornYear} onChange={this.handleText} value={pressUser?.demoGraphicInfo?.bornYear} label="In which year were you born?" />
                                                </div>
                                            </div>
                                            <div className="two_fields mb_10">
                                                <div className="field_row">
                                                    <DropDown name='bornCountry' options={countries} onChange={this.handleText} value={pressUser ?.demoGraphicInfo ?.bornCountry} label="In which country were you born?" />
                                                </div>
                                            </div>
                                            <div className="two_fields mb_10">
                                                <div className="field_row">
                                                    <DropDown name='primarilyReside' options={countries} onChange={this.handleText} value={pressUser ?.primarilyReside} label="In what country do you primarily reside?" />
                                                </div>
                                            </div>
                                            {pressUser ?.primarilyReside === 'United States' && <div className="two_fields mb_10">
                                                <div className="field_row">
                                                <DropDown name='primarilyStateReside' options={state} onChange={this.handleText} value={pressUser?.primarilyStateReside} label="Which state do you reside in?" />
                                                </div>
                                            </div>}
                                            <div className="check_question">
                                                <label className="chk_qustion_title">Which industry associations are you a member of? Check all that apply</label>
                                                <div className="d_flex two_col_check">
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "None") === 'None' ? true : false } value="None" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="None" id="industryNone" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "American Cinema Editors (ACE)") === 'American Cinema Editors (ACE)' ? true : false } value="American Cinema Editors (ACE)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="American Cinema Editors (ACE)" id="americanCinemaEditors" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "American Society of Cinema (ASC)") === "American Society of Cinema (ASC)" ? true : false } value="American Society of Cinema (ASC)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="American Society of Cinema (ASC)" id="americanSocietyofCinema" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Academy of Motion Picture Arts & Sciences (AMPAS)") === "Academy of Motion Picture Arts & Sciences (AMPAS)" ? true : false } value="Academy of Motion Picture Arts & Sciences (AMPAS)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Academy of Motion Picture Arts & Sciences (AMPAS)" id="ampas" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Academy of TV Arts & Sciences (ATAS)") === "Academy of TV Arts & Sciences (ATAS)" ? true : false } value="Academy of TV Arts & Sciences (ATAS)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Academy of TV Arts & Sciences (ATAS)" id="atas" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "American Film Institute (AFI)") === "American Film Institute (AFI)" ? true : false } value="American Film Institute (AFI)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="American Film Institute (AFI)" id="afi" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Art Directors Guild (ADG)") === "Art Directors Guild (ADG)" ? true : false } value="Art Directors Guild (ADG)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Art Directors Guild (ADG)" id="adg" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "British Academy of Film & Television (BAFTA)") === "British Academy of Film & Television (BAFTA)" ? true : false } value="British Academy of Film & Television (BAFTA)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="British Academy of Film & Television (BAFTA)" id="bafta" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Cinema Audio Society (CAS)") === "Cinema Audio Society (CAS)" ? true : false } value="Cinema Audio Society (CAS)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Cinema Audio Society (CAS)" id="cas" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Costume Designers Guild (CDG)") === "Costume Designers Guild (CDG)" ? true : false } value="Costume Designers Guild (CDG)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Costume Designers Guild (CDG)" id="cdg" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Directors Guild of America (DGA)") === "Directors Guild of America (DGA)" ? true : false } value="Directors Guild of America (DGA)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Directors Guild of America (DGA)" id="dga" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Hollywood Foreign Press Association (HFPA)") === "Hollywood Foreign Press Association (HFPA)" ? true : false } value="Hollywood Foreign Press Association (HFPA)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Hollywood Foreign Press Association (HFPA)" id="hfpa" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "International Alliance of Theatrical Stage Employees (IATSE)") === "International Alliance of Theatrical Stage Employees (IATSE)" ? true : false } value="International Alliance of Theatrical Stage Employees (IATSE)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="International Alliance of Theatrical Stage Employees (IATSE)" id="iatse" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "International Cinematographer’s Guild (ICG Publicists Guild)") === "International Cinematographer’s Guild (ICG Publicists Guild)" ? true : false } value="International Cinematographer’s Guild (ICG Publicists Guild)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="International Cinematographer’s Guild (ICG Publicists Guild)" id="icg" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Make Up Artists & Hair Stylists Guild (MUAHS)") === "Make Up Artists & Hair Stylists Guild (MUAHS)" ? true : false } value="Make Up Artists & Hair Stylists Guild (MUAHS)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Make Up Artists & Hair Stylists Guild (MUAHS)" id="muahs" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Motion Picture Association of America (MPAA)") === "Motion Picture Association of America (MPAA)" ? true : false } value="Motion Picture Association of America (MPAA)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Motion Picture Association of America (MPAA)" id="mpaa" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Producers Guild (PGA)") === "Producers Guild (PGA)" ? true : false } value="Producers Guild (PGA)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Producers Guild (PGA)" id="pga" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "SAG/AFTRA") === "SAG/AFTRA" ? true : false } value="SAG/AFTRA" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="SAG/AFTRA" id="sagaftra" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "SAGindie") === "SAGindie" ? true : false } value="SAGindie" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="SAGindie" id="sagindie" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "The Recording Academy") === "The Recording Academy" ? true : false } value="The Recording Academy" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="The Recording Academy" id="recordingAcademy" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Visual Effects Society (VES)") === "Visual Effects Society (VES)" ? true : false } value="Visual Effects Society (VES)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Visual Effects Society (VES)" id="ves" />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Women in Film") === "Women in Film" ? true : false } value="Women in Film" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Women in Film" id="womeninFilm"
                                                    />
                                                    <CheckBox checked={ pressUser && pressUser?.demoGraphicInfo && pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === "Writers Guild (WGA)") === "Writers Guild (WGA)" ? true : false } value="Writers Guild (WGA)" onChange={this.multiSelectCheck} type="checkbox" name="industryAssociation" label="Writers Guild (WGA)" id="wga" />
                                                    <div className='checkbox_field_row'>
                                                        <CheckBox name='industryAssociation' checked={pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === 'Other') === 'Other' ? true : false} value='Other' onChange={this.multiSelectCheck} label="Other (please specify)" type="checkbox" id="industryAssociationOther" />
                                                        {
                                                            pressUser?.demoGraphicInfo?.industryAssociation?.find(_ => _ === 'Other') === 'Other' ?

                                                                <div className="two_fields field_row inner_check_question">
                                                                    <div className="field_row">
                                                                        <TextField name='otherIndustryAssociation' onChange={this.handleText} value={pressUser?.demoGraphicInfo?.otherIndustryAssociation} />
                                                                        {this.state.otherIndustryAssociationError !== '' ? <div className='srv-validation-message' style={{ color: 'red' }}>{this.state.otherIndustryAssociationError}</div> : <span style={{ color: "red" }}> {this.validator.message("otherIndustryAssociation", pressUser?.demoGraphicInfo?.otherIndustryAssociation, "Required")}</span>}
                                                                    </div>
                                                                </div> : ''
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="two_fields mb_10">
                                                <div className="field_row">
                                                    <DropDown name='education' options={education} onChange={this.handleText} value={pressUser ?.demoGraphicInfo ?.education} label="What is your education level?" />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>

                                <div className="editcontentBox">
                                    <div className="editBoxheading">
                                        <p className="editBoxheading">Program Interests</p>
                                    </div>
                                    <div className="form_inner">
                                        <form>
                                            <div className="two_fields mb_10">
                                                <div className="field_row">
                                                    <DropDown name='primaryInterest' options={collabPrimaryInterest} onChange={this.handleText} value={pressUser ?.collab ?.primaryInterest} label="Select Primary Interest" />
                                                </div>
                                            </div>
                                            <div className="check_question">
                                                <label className="chk_qustion_title">Select Secondary Interests</label>
                                                <div className="d_flex d_flex_align_center two_col_check">
                                                    <CheckBox name="secondaryInterest" value="Acting & Directing Actors" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Acting & Directing Actors") === "Acting & Directing Actors" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Acting & Directing Actors" id="Acting & Directing Actors" />
                                                    <CheckBox name="secondaryInterest" value="Activism & Social Impact" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Activism & Social Impact") === "Activism & Social Impact" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Activism & Social Impact" id="Activism & Social Impact" />
                                                    <CheckBox name="secondaryInterest" value="Audio Storytelling" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Audio Storytelling") === "Audio Storytelling" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Audio Storytelling" id="Audio Storytelling" />
                                                    <CheckBox name="secondaryInterest" value="Comedy, Sci-fi & Horror" onChange={this.multiSelectCheck} checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Comedy, Sci-fi & Horror") === "Comedy, Sci-fi & Horror" ? true : false} disabled={this.state.disabledCheck} type="checkbox" label="Comedy, Sci-fi & Horror" id="Comedy_Sci-fi_Horror" />
                                                    <CheckBox name="secondaryInterest" value="Distribution & Marketing" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Distribution & Marketing") === "Distribution & Marketing" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Distribution & Marketing" id="Distribution & Marketing" />
                                                    <CheckBox name="secondaryInterest" value="Editing" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Editing") === "Editing" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Editing" id="Editing" />
                                                    <CheckBox name="secondaryInterest" value="Equity & Inclusion" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Equity & Inclusion") === "Equity & Inclusion" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Equity & Inclusion" id="Equity & Inclusion" />
                                                    <CheckBox name="secondaryInterest" value="Emerging Media" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Emerging Media") === "Emerging Media" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Emerging Media" id="Emerging Media" />
                                                    <CheckBox value="Financing & Funding" name="secondaryInterest" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Financing & Funding") === "Financing & Funding" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Financing & Funding" id="Financing & Funding" />
                                                    <CheckBox value="Shorts" name="secondaryInterest" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Shorts") === "Shorts" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Shorts" id="Shorts" />
                                                    <CheckBox value="Music & Sound Design" name="secondaryInterest" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Music & Sound Design") === "Music & Sound Design" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Music & Sound Design" id="Music & Sound Design" />
                                                    <CheckBox value="TV/Digital Series" name="secondaryInterest" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "TV/Digital Series") === "TV/Digital Series" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="TV/Digital Series" id="TV/Digital Series" />
                                                    <CheckBox value="Visual Storytelling" name="secondaryInterest" checked={pressUser ?.collab ?.secondaryInterest ?.find((_) => _ === "Visual Storytelling") === "Visual Storytelling" ? true : false} onChange={this.multiSelectCheck} disabled={this.state.disabledCheck} type="checkbox" label="Visual Storytelling" id="Visual Storytelling" />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    {/* <div className="two_fields mb_10">
                                        <div className="field_row">
                                            <DropDown name='secondaryInterest' options={collabSeconderyInterest} onChange={this.handleText} value={pressUser?.collab?.secondaryInterest} label="Select Secondary Interests"/>
                                        </div>
                                    </div>    */}
                                </div>
                                <div className="field_row text_center">
                                    <button className="uppercase" onClick={(e) => this.clear(e)}>Clear</button>
                                    <button className="uppercase active" disabled={this.state.dataLoader || (this.state.for === 'Edit' && !this.state.isEdited)} onClick={this.handleSubmit}>Submit {this.state.dataLoader &&
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    }</button>
                                </div>
                            </form>
                            {this.state.messageModal &&
                                <ModalMessage messageModal={this.state.messageModal} withoutEmail="Please complete all required fields before submitting." ClosemessageModal={this.ClosemessageModal} />
                            }
                            {this.state.imagePopup &&
                                <ModalMessage messageModal={this.state.imageValideMessage} withoutEmail="Please select valid image" ClosemessageModal={this.CloseImageModal} />
                            }
                            {
                                this.state.emailModal &&
                                <ModalMessage emailModal={this.state.emailModal} email={this.state.pressUserData?.email} CloseEmailModal={this.CloseEmailModal} />
                            }
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
const ForwardedCreatePressuser = forwardRef((props, ref) => (
    <CreatePressuser {...props} ref={ref} />
  ));
export default connect(mapStateToProps, null, null, { forwardRef: true })(ForwardedCreatePressuser);
